import { Department } from './department.interface';
import { MongooseTimestamp } from './util.interface';
import { Country } from './country.interface';

export interface Job extends MongooseTimestamp {
  _id?: string;
  contractType: string;
  category: JobCategory;
  status: JobStatus;
  title: string;
  mission: string;
  profile: string;
  remuneration: string;
  keywords?: string[];
  startDate: string;
  location: {
    department: Department | null;
    city: string;
    country: Country;
  };
}

export enum JobStatus {
  DRAFT,
  PUBLISHED,
  UNPUBLISHED,
}

export enum JobCategory {
  DEV,
  INFRA,
  WEB,
  TRADE,
}

export enum JobContract {
  CDI,
  CDD,
  TRAINEESHIP,
  ALTERNATION,
  INTERIM,
}
